import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PXPicklistQuestionModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXPicklistQuestionModalWrapper';

const Layout = () => {
  return (
    <PXPicklistQuestionModalWrapper>
      <MetaControlField attr={'description'} />
      <MetaControlField attr={'howYouFeelAboutMoney'} />
    </PXPicklistQuestionModalWrapper>
  );
};

export default Layout;
